// extracted by mini-css-extract-plugin
export default {"container":"ReCaptchaField_container__TkJJG","hide":"ReCaptchaField_hide__jTd3M"};